// extracted by mini-css-extract-plugin
export const root = "page-banner-module--root--1muXd";
export const image = "page-banner-module--image--3aw-T";
export const text = "page-banner-module--text--2bE1M";
export const anchorLink = "page-banner-module--anchorLink--PXDeE";